// Administration › Settings route (/admin/settings, Admin only; a #section hash such as #ai opens that group); the screen is SettingsPage.
import { createFileRoute } from "@tanstack/react-router";

import { SettingsPage } from "@/features/settings/SettingsPage";

export const Route = createFileRoute("/_app/admin/settings")({
  staticData: { crumb: "Settings" },
  component: SettingsPage,
});
